import { render } from "./FilterChipSection.vue?vue&type=template&id=30efbd64&scoped=true"
import script from "./FilterChipSection.vue?vue&type=script&lang=js"
export * from "./FilterChipSection.vue?vue&type=script&lang=js"

import "./FilterChipSection.vue?vue&type=style&index=0&id=30efbd64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30efbd64"]])

export default __exports__